import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.23_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.23_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.23_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AutoRefresh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MarketView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RefreshButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RefreshOnFocus.tsx");
